import {create} from 'zustand';

/**
 * Global store for Claim Details dialog.
 *
 * Motivation:
 * - The margin rail marker tree can unmount/collapse on click.
 * - Keeping dialog state globally prevents accidental unmount and spurious closes.
 */
const useClaimDetailsDialogStore = create((set) => ({
    isOpen: false,
    claim: null,
    referenceMarkId: null,
    perClaimCitations: [],

    open: ({claim, referenceMarkId = null, perClaimCitations = []} = {}) => {
        if (!claim) return;
        set({
            isOpen: true,
            claim,
            referenceMarkId,
            perClaimCitations: Array.isArray(perClaimCitations) ? perClaimCitations : [],
        });
    },

    close: () => {
        set({isOpen: false, claim: null, referenceMarkId: null, perClaimCitations: []});
    },
}));

export default useClaimDetailsDialogStore;

